import React, { useContext, useEffect, useState } from "react";
import { contactFormsIds, pagesIds } from "../../constants/api";
import { ValidateEmail } from "../../helpers/validations";
import "./index.css";
import robot from "../../assets/img/ContactUs/gif.min.gif";
import { invalidEmail } from "../../constants/messages";
import { GlobalContext } from "../../context/global/globalContext";
import { FormContext } from "../../context/form/formContext";
import { Notification } from "../../components/Notification";
import {ContactForm} from "../../components/ContactForm";

const ContactUs = () => {
  const { getCurrentPage, getPage } = useContext(GlobalContext);
  const page = getCurrentPage(pagesIds.contactUs);
  const { sendContactForm } = useContext(FormContext);

  const initialData = {
    your_name: "",
    your_email: "",
    your_message: "",
  };

  useEffect(() => getPage(pagesIds.contactUs), []);

  const [errors, setMessage] = useState({});
  const [userData, setData] = useState({ ...initialData });

  const changeData = (e) => {
    setMessage({
      ...errors,
      [e.target.name]: "",
    });

    setData({
      ...userData,
      [e.target.name]: e.target.value,
    });
  };

  const sendForm = (e) => {
    e.preventDefault();

    const errorsObj = {};

    for (var field in userData) {
      if (userData[field] === "") {
        errorsObj[field] = `${field
          .split("_")[1]
          .toLocaleLowerCase()} can't be empty!`;
      }
    }

    if (!ValidateEmail(userData["your_email"])) {
      errorsObj["your_email"] = invalidEmail;
    }

    if (
      !errorsObj.hasOwnProperty("your_name") &&
      !errorsObj.hasOwnProperty("your_email")
    ) {
      sendContactForm(userData, contactFormsIds.contactUs);
      setData({ ...initialData });
    } else {
      setMessage(errorsObj);
    }
  };

  return (
    <div className="wr col contactUs">
      {page?.id && (
        <div className="content row jsb">
          <Notification />
          <div className="content_left col flex  jc">
            <h1 className="titleLeft">Contact us</h1>
            <img className="gif" src={robot} alt="" />
          </div>
          <div className="content_right col flex center jc">
            <div className="info col">
              <div className="row info__itemWr">
                <div className="info__item col">
                  <span className="info__itemTitle">email</span>
                  <span className="info__itemBody">
                    {page.custom_fields.email}
                  </span>
                </div>
                <div className="info__item col">
                  <span className="info__itemTitle">phone</span>
                  <span className="info__itemBody">
                    {page.custom_fields.phone}
                  </span>
                </div>
              </div>
            </div>
            <ContactForm
              sendForm={sendForm}
              changeData={changeData}
              errors={errors}
              userData={userData}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactUs;
